// Updated DownloadNotification.js without the Play First Song button

import React from 'react';
import styles from '../styles/DownloadNotification.module.css';

const DownloadNotification = ({ isVisible, onClose, onShowHelp }) => {
  if (!isVisible) return null;

  return (
    <div className={styles.notificationContainer}>
      <button className={styles.closeButton} onClick={onClose}>×</button>
      
      <h3 className={styles.notificationTitle}>How to download your songs:</h3>
      
      <ol className={styles.downloadSteps}>
        <li>
          Find your song below and click the <strong>Download MP3</strong> button
        </li>
        <li>
          <strong>On a computer:</strong> Right-click on the Download button and select <strong>"Save link as..."</strong> or <strong>"Download linked file"</strong>
        </li>
        <li>
          <strong>On a mobile device:</strong> Press and hold the Download button, then select the download option
        </li>
      </ol>
      
      <div className={styles.helpSection}>
        Need help? <button 
          onClick={onShowHelp}
          className={styles.helpLinkOrange}
        >
          View step-by-step guide
        </button>
      </div>
    </div>
  );
};

export default DownloadNotification;